import { MapTo } from '@adobe/aem-react-editable-components';
import ConsumerReport, { ConsumerReportEditConfig } from './ConsumerReport';

export default MapTo('cob-corp-acquisition/components/creditonebank/consumer-report')(ConsumerReport, ConsumerReportEditConfig);